import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import * as Yup from "utils/yup";

import { AMOUNT_FILTER_KEYS } from "../types/filters";

import type { AmountFilterKeys } from "../types/filters";

export function createAmountFilterSchema(
  filterKeys: AmountFilterKeys = {
    amountFrom: AMOUNT_FILTER_KEYS.AMOUNT_FROM,
    amountTo: AMOUNT_FILTER_KEYS.AMOUNT_TO,
  }
) {
  return {
    [filterKeys.amountFrom]: Yup.number().nullable(),
    [filterKeys.amountTo]: Yup.number()
      .nullable()
      .when(filterKeys.amountFrom, ([amountFrom], schema) => {
        if (Boolean(amountFrom)) {
          return schema.min(
            amountFrom,
            COMMON_TRANSLATION_KEYS.theAmountToValueMustBeGreater
          );
        }

        return schema;
      }),
  };
}
